<script setup lang="ts">
import {RouterView, useRoute} from 'vue-router'
import {Model} from "@/app/Model";
import {watch} from "vue";
import NotLogged from "@/views/NotLogged.vue";
import {Comms} from "@/app/Comms";
import ModalDettaglio from "@/components/atomics/ModalDettaglio.vue";
import CookieView from "@/views/CookieView.vue";

let model: Model = Model.getReactiveInstance();

const route = useRoute()
watch(() =>  route, (newValue, oldValue) => {
  let vPercorso: string = "";
  let vTipoPagina: string = "";

  if (newValue.name == "home") {
    model.penResetData();
    model.famResetData();
    model.resResetData();

    vTipoPagina = "HP";
  }

  if (newValue.name == "pen_percorso") {
    model.penResetData();

    vPercorso = "Penale";
    vTipoPagina = "Percorso";
  }
  if (newValue.name == "pen_dashboard") {
    model.penCopyPercorsoToDashBoard();

    vPercorso = "Penale";
    vTipoPagina = "Dashboard";
  }

  if (newValue.name == "fam_percorso") {
    model.famResetData();

    vPercorso = "Famiglia";
    vTipoPagina = "Percorso";
  }

  if (newValue.name == "fam_dashboard") {
    model.famCopyPercorsoToDashBoard();

    vPercorso = "Famiglia";
    vTipoPagina = "Dashboard";
  }
  if (newValue.name == "res_dashboard") {
    model.resCopyPercorsoToDashBoard();

    vPercorso = "Responsabilita";
    vTipoPagina = "Dashboard";
  }
  if (newValue.name == "res_percorso") {
    model.resResetData();

    vPercorso = "Responsabilita";
    vTipoPagina = "Percorso";
  }
  //@ts-ignore
  window.gtagO({
    'event':'pageview',
    'utenteLoggato': (!Comms.hf_isNotLogged()).toString(),
    'tipoPagina': vTipoPagina,
    'percorso': vPercorso
  });
},
    { deep: true });
</script>

<script lang="ts">
import {Starter} from "@/app/Starter";
export default {
  name: "app",
  components: {
  },
  mounted() {
    let starter: Starter = Starter.getInstance();
    starter.setup();
  }
};
</script>

<template>
  <ModalDettaglio></ModalDettaglio>
  <CookieView v-if="route.name == 'cookie'" />
  <NotLogged v-else-if="model.returnedToken==''"></NotLogged>
  <RouterView v-else />
  <button type="button" id="triggerModalDettaglio" class="not-visible" data-bs-toggle="modal" data-bs-target="#dettaglioModal"></button>
</template>
